var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.375,
    y: 1.875,
    width: 8.25,
    height: 11.25,
    rx: 1.125,
    stroke: "#D4BC87",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4.125H4.5V4.875H5.25V4.125ZM3.375 5.25V15.375H4.125V5.25H3.375ZM4.5 16.5H12V15.75H4.5V16.5ZM13.125 15.375V14.25H12.375V15.375H13.125ZM12 16.5C12.6213 16.5 13.125 15.9963 13.125 15.375H12.375C12.375 15.5821 12.2071 15.75 12 15.75V16.5ZM4.5 4.125C3.87868 4.125 3.375 4.62868 3.375 5.25H4.125C4.125 5.04289 4.29289 4.875 4.5 4.875V4.125ZM3.375 15.375C3.375 15.9963 3.87868 16.5 4.5 16.5V15.75C4.29289 15.75 4.125 15.5821 4.125 15.375H3.375Z",
    fill: "#D4BC87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.74de84b0ff2179148058409797bc50a3.svg";
export { ForwardRef as ReactComponent };